import React from "react";
// import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {  SvgIcon } from "@mui/material";
import {  Button } from "@mui/material";
import { toast } from "react-toastify";



function DownloadCSV({ base64CSV, fileName }) {

  const handleDownloadClick = () => {
    // Decode the Base64 string to binary data
    const binaryData = atob(base64CSV);

    // Create a Uint8Array from the binary data
    const array = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      array[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the Uint8Array
    const blob = new Blob([array], { type: "text/csv" });
    // Create a download link
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileName;

    // Trigger the download
    downloadLink.click();
    toast.info('Download Completed',{
        autoClose: 3500,
      })
  };

  return (
    <div>

      <Button 
      variant="contained"
      className="btn-sty"
      style={{marginLeft:'33px'}}
      onClick={handleDownloadClick}>Download <SvgIcon fontSize="small" className="ms-2">
                      <FileDownloadIcon />
                    </SvgIcon></Button>
    </div>
  );
}

export default DownloadCSV;